import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";
import Swal from "sweetalert2";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddProductImage = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [productImages, setProductImages] = useState([]);
  const [productDrpData, setProductDrpData] = useState([]);
  const [imagePreview, setImagePreview] = useState("");
  const fileInputVideoRef = useRef(null);
  const [formData, setFormData] = useState({
    product_id: null,
    file: null,
    image: null,
  });

  const getProductData = () => {
    axios.post(API_URL.PRODUCT_ONLY, {}).then((res) => {
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.category?.name + ' - ' + caw.name,
            value: caw.id,
            product_id: caw.product_id,
            weight: caw.weight,
            price: caw.price,
          };
        });
        setProductDrpData(cd);
      });
  };

    const getProductImages = (product_id) => {
        if (product_id) {
            axios.post(API_URL.PRODUCT_IMAGES, { product_id: product_id }).then((res) => {
                if (res.data.status === 1) {
                    setProductImages(res.data.data);
                }
            });
        }
    };

    const blobToFile = (theBlob, fileName) => {
        theBlob.lastModifiedDate = new Date();
        return new File([theBlob], fileName, { type: theBlob.type });
    }

    const dataURLtoBlob = (dataurl) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    const dataURLtoFile = (dataurl, filename) => {
        const blob = dataURLtoBlob(dataurl);
        setFormData({
            ...formData,
            image: blobToFile(blob, filename),
        });
    }

  const onSave = () => {
    if (formData.product_id && (formData.image || formData.file)) {
      setLoading(true);
      var prodFormData = new FormData();
      if (id) {
        prodFormData.append("id", id);
      }
      if (formData.image) {
        prodFormData.append("image", formData.image);
      }
      if (formData.product_id) {
        prodFormData.append("product_id", formData.product_id);
      }
      if (formData.file) {
        prodFormData.append("file", formData.file);
      }
      axios
        .post(API_URL.PRODUCT_ADD_IMAGE, prodFormData)
        .then((res) => {
            setLoading(false);
          if (res.data.status === 1) {
            toast.success('Saved Successfully', { autoClose: 3000, position: "top-right" });
            getProductImages(formData.product_id)
            if (fileInputVideoRef.current) {
                fileInputVideoRef.current.value = '';
            }
            setFormData({
                product_id: formData.product_id,
                file: null,
                image: null,
            });
            setImagePreview(null);
          }
        })
    } else {
        setLoading(false);
        toast.error('Please enter valid details.', { autoClose: 3000, position: "top-right" });
    }
  };

  const deleteImage = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PRODUCT_DELETE_IMAGE, { id: row.id, product_id: row.product_id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = productImages.filter((r) => r.id != row.id);
              setProductImages(newData);
              toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(row.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getProductData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>Add Image or Video</h1>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                <label htmlFor="Size">Product<span className="required-star">*</span></label>
                                <Select
                                    options={productDrpData}
                                    value={productDrpData.find((r) => r.value == formData.product_id)}
                                    styles={customStyles}
                                    onChange={(e) => {
                                        getProductImages(e.value)
                                        setFormData({ ...formData, product_id: e.value })
                                    }}
                                />
                                </div>
                            </div>
                            <div className="col-md-12 position-relative">
                                <div className="form-group">
                                <label>Video (MP4)</label>
                                <input
                                    className={'form-control'}
                                    accept="video/mp4"
                                    ref={fileInputVideoRef}
                                    disabled={id}
                                    name="file"
                                    type="file"
                                    id="file"
                                    onChange={(e) => {
                                    if (e.target.files && e.target.files[0]) {
                                        setFormData({
                                        ...formData,
                                        file: e.target.files[0],
                                        });
                                    }
                                    }}
                                />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                <label>Image</label>
                                <div>
                                    <Crop
                                        imagePreview={imagePreview}
                                        cropShape={"round"}
                                        guid={""}
                                        width={250}
                                        height={250}
                                        onChangeCropper={async ({
                                            fileCroppedBase64,
                                        }) => {
                                            dataURLtoFile(fileCroppedBase64, 'cropped_image.png');
                                            setImagePreview(fileCroppedBase64)
                                        }}
                                    />
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="table-responsive">
                            <table className="table">
                            <thead className="">
                                <tr>
                                    <th>#</th>
                                    <th style={{ width: "150px" }}>Image</th>
                                    <th>Video</th>
                                    <th className="text-center" style={{ width: "200px" }}>
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {productImages.map((row, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{(key + 1)}</td>
                                    <td>
                                        { row.image && <div
                                        style={{
                                            height: "50px",
                                            width: "50px",
                                            backgroundImage: "url(" + row.image + ")",
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        ></div> }
                                    </td>
                                    <td>
                                        {(row.video_file) ? <Link to={row.video_file} target="_blank" className="text-primary">View File</Link> : "No Video Uploaded"}
                                    </td>
                                        <td
                                            className="d-flex justify-content-center gap-2" style={{ width: "200px" }}>
                                            <button onClick={() => deleteImage(row)} className="btn btn-sm btn-danger">
                                                <i className="fa fa-trash me-1"></i> Delete
                                            </button>
                                        </td>
                                    </tr>
                                );
                                })}
                            </tbody>
                            </table>
                        </div>
                    </div>

                  <div className="col-md-12">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={onSave}
                        disabled={loading || (!formData.product_id || (!formData.image && !formData.file))}
                        className="btn btn-primary"
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProductImage;
